<template>
  <div id="account" v-if="showing" class="account">
    <div class="account-inner">
      <div class="sign-in" v-if="state === 'signin'">
        <h2>Sign In</h2>
        <div class="panel-content">
          <form v-on:submit.prevent="signInSubmit">
            <label for="email" >Email Address</label>
            <input type="email" placeholder="Email" name="email" v-model='formemail' required>
            <label for="email">Password</label>
            <input type="password" placeholder="Password" name="password" v-model='formpassword' required>
            <div class="error" v-if="errormessage">{{errormessage}}</div>
            <button type="submit" v-bind:disabled="loading">Sign In</button>
          </form>

          <a @click="state='forgot'" class="forgotlink">Forgot your password?</a>

          <h4>New Users</h4>
          <p>Create an account to save and manage your pullsheets</p>
          <a @click="state='signup'" class="signuplink">Sign Up Now</a>
        </div>
      </div>
    </div>

      <div class="sign-up" v-if="state === 'signup'">
        <h2>Sign Up</h2>
        <div class="panel-content">
          <p>Create an account to save and manage your pullsheets.</p>
          <form v-on:submit.prevent="signUpSubmit">
            <label for="email">Email Address</label>
            <input type="email" placeholder="Email" name="email" v-model='formemail' required>
            <label for="email">Password</label>
            <input type="password" placeholder="Password" v-model='formpassword' name="password" required>
            <div class="error" v-if="errormessage">{{errormessage}}</div>
            <button type="submit">Create Account</button>
          </form>

          <a @click="state='signin'" class="goback">Go Back</a>
        </div>
      </div>

      <div class="forgot" v-if="state === 'forgot'">
        <h2>Reset Password</h2>
        <div class="panel-content">
          <p>Enter your email below and we'll send you a link with instructions to reset your password.</p>
          <form v-on:submit.prevent="resetSubmit">
            <label for="email">Email Address</label>
            <input type="email" placeholder="Email" name="email" v-model='formemail' required>
            <div class="error" v-if="errormessage">{{errormessage}}</div>
            <button type="submit" v-bind:disabled="loading">Submit</button>
          </form>

          <a @click="state='signin'" class="goback">Go Back</a>
        </div>
      </div>

      <div class="confirmation" v-if="state === 'confirm'">
        <h2>{{confirmheader}}</h2>
        <div class="panel-content">
          <p>{{confirmmessage}}</p>
          <a @click="state='signin'" class="goback">Go Back</a>
        </div>
      </div>

      <div class="loggedin" v-if="state === 'loggedin'">
        <h2>Account</h2>
        <div class="panel-content">
          <p>You are signed in as <strong>{{user.email}}</strong>.</p>

          <a @click="signOut()" class="signout">Sign Out</a>
        </div>
      </div>

    </div>


  </div>
</template>

<script>
export default {
  name: 'Account',
  props: {
    showing: false
  },
  data () {
    return {
      state: 'signin',
      confirmheader: '',
      confirmmessage: '',
      user: this.$root.user,
      formemail: '',
      formpassword: '',
      loading: false,
      errormessage: false
    }
  },
  methods: {
    signInSubmit: function () {
      this.loading = true
      this.errormessage = false
      this.$http.get(this.$root.apiurl + 'user/login',
        {
          params: {
            email: this.formemail,
            password: this.formpassword
          }
        }).then(response => {
          if (response.body.success) {
            this.user.loggedIn = true
            this.user.session = true
            this.user.email = response.body.email
            this.user.token = response.body.token
            this.loading = false
            this.errormessage = false
            this.$cookie.set('plu', response.body.email + '||' + response.body.token, {expires: 365, domain: '.therenees.com'})
            this.$cookie.delete('pla', {domain: '.therenees.com'})
            this.$root.logActivity('Signed In')
            this.state = 'loggedin'
          } else {
            this.loading = false
            this.$root.logActivity('Failed Sign In')
            this.errormessage = response.body.message
          }
        }, response => {
          this.loading = false
          this.errormessage = response.statusText
        })
    },
    signUpSubmit: function () {
      this.loading = true
      this.errormessage = false
      this.$http.get(this.$root.apiurl + 'user/register',
        {
          params: {
            email: this.formemail,
            password: this.formpassword
          }
        }).then(response => {
          if (response.body.success) {
            this.user.loggedIn = true
            this.user.session = true
            this.user.email = response.body.email
            this.user.token = response.body.token
            this.loading = false
            this.errormessage = false
            this.$cookie.set('plu', response.body.email + '||' + response.body.token, {expires: 365, domain: '.therenees.com'})
            this.$cookie.delete('pla', {domain: '.therenees.com'})
            this.state = 'loggedin'
            this.$root.logActivity('Created new account')
          } else {
            this.loading = false
            this.errormessage = response.body.message
          }
        }, response => {
          this.loading = false
          this.errormessage = response.statusText
        })
    },
    resetSubmit: function () {
      this.loading = true
      this.errormessage = false
      this.$http.get(this.$root.apiurl + 'user/resetpassword',
        {
          params: {
            email: this.formemail
          }
        }).then(response => {
          if (response.body.success) {
            this.loading = false
            this.errormessage = false
            this.state = 'confirm'
            this.confirmheader = 'Password Reset'
            this.confirmmessage = 'We just sent you an email with a link to reset your password.'
            this.$root.logActivity('Submtited password reset')
          } else {
            this.loading = false
            this.errormessage = response.body.message
          }
        }, response => {
          this.loading = false
          this.errormessage = response.statusText
        })
    },
    signOut: function () {
      this.$cookie.delete('plu', {domain: '.therenees.com'})
      this.user.loggedIn = false
      this.user.session = false
      this.user.email = false
      this.user.token = false
      this.$root.activePullSheet.token = false
      this.$root.activePullSheet.items.splice(0, this.$root.activePullSheet.items.length)
      this.$root.activePullSheet.loaded = false
      this.$root.activePullSheet.name = 'Untitled Pullsheet'

      this.state = 'signin'
    }
  },
  created () {
    if (this.user.loggedIn) this.state = 'loggedin'
  },
  watch: {
    'user': {
      handler: function (val, oldVal) {
        if (val.loggedIn && !oldVal.loggedIn) this.state = 'loggedin'
        if (!val.loggedIn && oldVal.loggedIn) this.state = 'signin'
      },
      deep: true
    },
    state: function () {
      this.loading = false
      this.errormessage = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";
#account {
  z-index: 100;
  position: fixed;
  background: #FFF;
  text-align: right;
  box-sizing: border-box;
  padding: 1em;
  border: 1px solid #DCDCDC;
  box-shadow: 1px 1px 24px rgba(0,0,0,.04);
  top: 71px;
  right: 2%;
  width: 96%;
  @include bp(most) {
    right: 186px;
    width: 350px;
    top: 104px;
  }
    &:before {
      content: "";
      position: absolute;
      top: -15px;
      border-width: 0 15px 15px;
      border-style: solid;
      border-color: #DCDCDC transparent;
      display: block;
      width: 0;
      right: 31px;
      @include bp(most) {
        right: 30px;
      }
    }
    &:after {
      content: "";
      position: absolute;
      top: -14px;
      border-width: 0 14px 14px 14px;
      border-style: solid;
      border-color: #fff transparent;
      display: block;
      width: 0;
      right: 32px;
      @include bp(most) {
        right: 31px;
      }
    }
    &.floating {
      @include bp(most) {
        position: absolute;
        top: 79px;
        right: calc(5% + 144px);
      }
    }
}

h2 {
  font-size: 1.75em;
  font-weight: 300;
  color: #8A8A8A;
  border-bottom: 1px solid #CECECE;
  margin: 0px;
  line-height: 1.4;
  padding: 0 0 .25em 0;
}

.panel-content {
  overflow-y: auto;
  max-height: calc(78vh - 80px);
  @include bp(most) {
    max-height: calc(85vh - 80px);
  }
}


form {
  margin: 1em 0;
  label {
    display: block;
    font-family: $noto;
    color: #8A8A8A;
    margin: .25em 0;
  }
  input {
    font-family: $noto;
    display: block;
    text-align: right;
    width: 100%;
    outline: none;
    padding: .75em;
    font-size: 1em;
    box-sizing: border-box;
    margin-bottom: .75em;
    border: 1px solid #7D7D7D;
    border-radius: 3px;
    color: $notblack;
    &::placeholder {
      color: #CFCFCF;
    }
  }
  button {
    background: $purple;
    outline: none;
    border: 0px none;
    border-radius: 3px;
    font-family: $montserrat;
    color: #FFF;
    font-weight: 300;
    font-size: 1.25em;
    padding: .25em 1em;
    line-height: 1.4;
    &:disabled {
      background: #7d7d7d;
    }
  }
}

div.error {
  color: #CF0000;
  margin: .5em 0;
}

a {
  color: $purple;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

h4 {
  font-family: $noto;
  font-weight: bold;
  color: $notblack;
  margin: 1.5em 0 0;
}

p {
  color: #8A8A8A;
  margin: .75em 0 .75em;
  strong {
    font-weight: 400;
    color: $notblack;
  }
}

</style>



// WEBPACK FOOTER //
// Account.vue?1c1afcf6